import React from "react";
import "../CSS/SubProduct.css";
import teacozy from "../Assets/Devour/Product_Main/TEA COZY.jpg";

function TeaCozy() {
  window.scrollTo(0, 0);

  return (
    <div className="product-main">
      <div>
        <div className="sub-product-head">
          <h3>Tea Cozy</h3>
        </div>
        <div className="sub-product-flex">
          <img src={teacozy} />
        </div>
      </div>
    </div>
  );
}
export default TeaCozy;
